/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * LP trade correction DTO
 */
export interface CorrectTradeRequest {
  /**
   * Trade ID
   */
  tradeId: number;
  /**
   * New quantity. If zero - trade will be just cancelled
   */
  quantity: number;
  /**
   * New price.
   */
  price: number;
}
